<template>
    <div class="referrer_box">
        <div class="referrerNav_topBox">
            <el-button round @click="addSuburbAction">Add Suburb</el-button>
            <div  class="searchBxo">
                <i class="el-icon-search" style="margin-top:11px"></i>
                <input type="text" v-model="search" @keyup.enter="gethome" class="searchInput" placeholder="Search">
            </div>
        </div>
        <div style="background:#fff;margin-top:30px;padding:30px;border-radius: 7px;">
            <el-table
            :data="tableData"
            style="width: 100%;">
                <el-table-column
                    prop="name"
                    width="200"
                    label="Suburb">
                </el-table-column>
                <el-table-column
                    prop="postcode"
                    width="200"
                    label="Postcode">
                </el-table-column>
                <el-table-column
                    prop="state"
                    width="200"
                    label="State">
                </el-table-column>
                
            </el-table>
             <!-- 分页 -->
            <div class="fen" v-if="total">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-size="25"
                    layout="total, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>

        <el-dialog
        title=""
        :visible.sync="delDio"
        :append-to-body="true"
        class="accountdio"
        :show-close="false"
        center
        width="470px">
            <div style="margin-top:0px;text-align:center;" class="engMsg">By deleting the property, you will also delete all content to the property. Are you sure you want to continue?</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDio = false" style="border:none;">Cancel</el-button>
                <el-button type="primary" @click="delhouse" style="background:#ec6a60;border:none;width:120px;">Delete</el-button>
            </span>
        </el-dialog>

        <my-sharing v-if="showMsgDio" :showMsgDio='showMsgDio' @cancelSharing='cancelSharing' @cancelSharingSuccess='cancelSharingSuccess' :id='detail.propertyId' :url='detail.shareUrl' :password='detail.sharePassWord' :titMsg="detail.shareFlag?'Close Sharing':'Open Sharing'"></my-sharing>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import sharing from '../common/sharing'
export default {
    data() {
        return {
            showMsgDio:false,
            detail:{
                shareUrl:'',
                sharePassWord:'',
                shareFlag:0
            },
            search:'',
            tableData:[],
            status:'All',
            page:1,
            size:25,
            total:100,
            delDio:false,
            msg:''
        }
    },
    components:{
        'my-sharing':sharing
    },
    methods: {
        ...mapActions(['getAdvertisingLists', 'getSuburbLists']),
        cancelSharing(){ // 取消分享
            this.showMsgDio = false
        },
        cancelSharingSuccess(){ // 改变成功
            this.showMsgDio = false
            this.gethome()
        },
        handleSizeChange(val) {
            this.size=val
            this.gethome()
        },
        handleCurrentChange(val) {
            this.page=val
            this.gethome()
        },
        gethome(){ // 获取列表
            let pat={
                page:this.page,
                size:this.size,
                lineType:'online',
                proertyType:this.status=='All'?'all':this.status,
                search:this.search,
            }
            this.getSuburbLists({pat:pat,callback:this.callback})
        },
        delhouse(){ // 删除
            this.deleteHouse({pat:{propertyId:this.msg.propertyId},callback:this.callback})
        },
        callback(resp,status){
            switch (status) {
                
                case 'getSuburbLists':
                    if(resp.code==0){
                        this.tableData=resp.data
                        this.total=resp.data.totalRecord
                    }else{
                        Utils.alert('',resp.message,'error')
                    }
                break;
            }
        },
        showDetail(key,val){
            if(key==1){
                this.$router.push({path:'/propertyDetail',query:{pid:val.propertyId}})
            }
        },
        addSuburbAction(){ // Add Suburb
            this.$router.push({path:'/addsuburb'})
        }
    },
    mounted() {
        this.gethome()
    },
    activated(){
        let query=this.$route.query
        if(query.from=='a'){
            this.gethome()
        }
    }
}
</script>

<style lang='scss'>
    .referrer_box{
        background: #f2f2f2;
        padding:30px 40px;
        height: 100%;
        .checkBoxpro{
            display: inline-block;
            width: 150px;
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/suburb/suburb.vue